
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import Path from "@/lib/common/path";
import PostPolicy from "@/lib/model/gateway/post-policy";
import gateway from "@/lib/request/gateway";
import E, { KEditor } from "./ckeditor";
import _ from "lodash";

declare const CKEDITOR: E;

@Component
export default class Editor extends Vue {
  @Model("change", { type: String }) private readonly value!: string;
  @Prop({ type: String, default: "" }) private readonly placeholder!: string;
  @Prop({ type: String, default: "CKEnone" })
  private readonly keyIndex!: string;
  @Prop({ type: String, default: "none" }) private readonly tabIndex!: string;
  @Prop({ type: Boolean, default: false }) disable!: boolean; //只读模式
  @Prop({ type: Boolean, default: true }) showUploadImage!: boolean;
  @Prop({ type: Boolean, default: false }) imgIsPill!: boolean;
  name = "editor";
  editor!: null | KEditor;
  policyMap: _.Dictionary<PostPolicy> = {};
  seq: number[] = [];
  seqIdx = 0;
  //此value仅仅是函数传入  用户输入字符仅在ckeditor自身监听绑定生效
  @Watch("value")
  onValueChange(to: string) {
    if (to !== String(this.editor?.getData())) {
      this?.setData(to);
    }
  }
  @Emit("change")
  change(value: string) {
    return value;
  }
  //清空 or 赋值
  open(clear = false) {
    const t = clear === false ? this.value : "";
    this?.setData(t);
  }
  private setData(value: string) {
    if (this.editor) {
      const idx = this.seqIdx++;
      this.seq.push(idx);
      if (idx !== this.seq[0]) {
        const interval = setInterval(() => {
          if (idx === this.seq[0]) {
            this.editor?.setData(value, {
              callback: () => {
                this.seq.shift();
              }
            });
            clearInterval(interval);
          }
        }, 50);
      } else {
        this.editor?.setData(value, {
          callback: () => {
            this.seq.shift();
          }
        });
      }
    }
  }

  fkCKE() {
    //
  }

  setValue(value: string) {
    this.change(value);
  }

  getValue(): string {
    return this.editor ? this.editor.getData() : "";
  }

  insertText(text: string) {
    this.editor?.insertText(text);
  }

  insertHtml(html: string) {
    // const h =
    //   '<span class="h-card">' +
    //   '<a  class="p-name u-email">' +
    //   html +
    //   "</a>" +
    //   "</span>";
    // const img =
    //   "<img style='height:20px;' src='http://examhr.5kong.com/img/default-head.ce6f5ea4.png'/>";
    this.editor?.insertHtml(html);
  }

  mounted() {
    this.init();
  }

  // 检查是否只读，如果disable为true应设为只读
  @Watch("disable", { immediate: true })
  checkOnlyRead(n: any) {
    setTimeout(() => {
      if (this.editor) {
        (this.editor as any)?.setReadOnly(n);
      }
    }, 500);
    setTimeout(() => {
      if (this.editor) {
        (this.editor as any)?.setReadOnly(n);
      }
    }, 1000);
    setTimeout(() => {
      if (this.editor) {
        (this.editor as any)?.setReadOnly(n);
      }
    }, 2000);
  }
  init() {
    const toolbarGroups = [
      {
        name: "basicstyles",
        groups: ["basicstyles", "cleanup"]
      }
    ];

    toolbarGroups.push(
      ...[
        // {
        //   name: "other",
        //   items: [
        //     "JustifyLeft",
        //     "JustifyCenter",
        //     "JustifyRight",
        //     "JustifyBlock",
        //   ],
        // },
        //{ name: "links", groups: ["links", "list"] },
        { name: "colors", groups: ["colors"] },
        // { name: "styles", groups: ["styles"] },
        {
          name: "paragraph",
          groups: ["indent", "blocks"]
        },
        {
          name: "paragraph",
          groups: ["list", "indent", "blocks", "align", "bidi"]
        }
      ]
    );
    if (this.showUploadImage) {
      toolbarGroups.push({ name: "insert", groups: ["insert"] });
    }
    this.editor = CKEDITOR.replace(this.$refs.editor as HTMLElement, {
      readOnly: true,
      allowedContent: true,
      extraPlugins: "image2,uploadimage,justify,showblocks",
      removePlugins: "image",
      toolbarGroups: toolbarGroups,
      removeButtons:
        "Underline,Strike,Subscript,Superscript,RemoveFormat,HorizontalRule,SpecialChar,Outdent,Indent,About,Print,NewPage,Save,Templates,Scayt,SelectAll,Find,Replace,Form,Checkbox,Radio,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,Language,Anchor,Flash,Smiley,Iframe,ShowBlocks,CopyFormatting,FontSize,Font,Cut,Copy,Maximize,ExportPdf,BidiRtl,BidiLtr,PageBreak",
      exportPdf_tokenUrl: "/",
      removeDialogTabs: "image:advanced;link:advanced",
      uploadUrl: "https://oss.hina.com",
      filebrowserImageUploadUrl: "https://oss.hina.com"
    });
    // 设置结果页控制图片样式
    if (this.imgIsPill) {
      CKEDITOR.addCss(
        ".cke_widget_wrapper[data-cke-display-name='图像']{width:100%;} .cke_widget_wrapper[data-cke-display-name='图像'] img{width:100%;height:auto;} "
      );
    }
    //解决ck5的反人类换行
    this.editor.config.enterMode = CKEDITOR.ENTER_BR;
    this.editor.config.shiftEnterMode = CKEDITOR.ENTER_P;
    this.editor.config.forcePasteAsPlainText = true; //强制去掉复制来的文本样式

    this.setData(this.value);

    this.editor.on("change", evt => {
      //用户输入值回传 相当于手动双向绑定model
      // if (this.value !== String(this.editor?.getData())) {
      this.change(evt.editor.getData());
      // }
    });
    this.editor.on("fileUploadRequest", evt => {
      const fileLoader = evt.data.fileLoader,
        formData = new FormData(),
        xhr = fileLoader.xhr;
      gateway
        .anonymousGetPostPolicy(evt.data.fileLoader.fileName)
        .then(policy => {
          this.policyMap[fileLoader.id] = policy;
          formData.set("OSSAccessKeyId", policy.accessid);
          formData.set("policy", policy.policy);
          formData.set("Signature", policy.signature);
          formData.set("key", policy.dir);
          formData.set("file", evt.data.fileLoader.file);
          formData.set("success_action_status", "201");
          xhr.open("POST", policy.cdn, true);
          xhr.send(formData);
        })
        .catch(() => {
          evt.cancel();
        });

      // Prevented the default behavior.
      evt.stop();
    });
    this.editor.on("fileUploadResponse", evt => {
      // Prevent the default response handler.
      evt.stop();
      // Get XHR and response
      const data = evt.data;
      const xhr = evt.data.fileLoader.xhr;
      if (xhr.status !== 201) {
        evt.cancel();
      } else {
        const policy = this.policyMap[data.fileLoader.id];
        data.url = Path.join(policy.cdn, encodeURIComponent(policy.dir));
      }
    });

    // (CKEDITOR as any).disableAutoInline = true;

    // (CKEDITOR as any).plugins.add("hcard", {
    //   requires: "widget",
    //   init: function (editor: any) {
    //     editor.widgets.add("hcard", {
    //       allowedContent:
    //         "span(!h-card); a[href](!u-email,!p-name); span(!p-tel)",
    //       requiredContent: "span(h-card)",
    //       pathName: "hcard",

    //       upcast: function (el: any) {
    //         return el.name == "span" && el.hasClass("h-card");
    //       },
    //     });

    //     // This feature does not have a button, so it needs to be registered manually.
    //     editor.addFeature(editor.widgets.registered.hcard);

    //     // Handle dropping a contact by transforming the contact object into HTML.
    //     // Note: All pasted and dropped content is handled in one event - editor#paste.
    //     editor.on("paste", function (evt: any) {
    //       const contact = evt.data.dataTransfer.getData("contact");
    //       if (!contact) {
    //         return;
    //       }

    //       evt.data.dataValue =
    //         '<span class="h-card">' +
    //         '<a href="mailto:' +
    //         contact.email +
    //         '" class="p-name u-email">' +
    //         contact.name +
    //         "</a>" +
    //         " " +
    //         '<span class="p-tel">' +
    //         contact.tel +
    //         "</span>" +
    //         "</span>";
    //     });
    //   },
    // });

    // (CKEDITOR as any).on("instanceReady", function () {
    //   // When an item in the contact list is dragged, copy its data into the drag and drop data transfer.
    //   // This data is later read by the editor#paste listener in the hcard plugin defined above.
    //   (CKEDITOR as any).document
    //     .getById("contactList")
    //     .on("dragstart", function (evt: any) {
    //       // The target may be some element inside the draggable div (e.g. the image), so get the div.h-card.
    //       const target = evt.data.getTarget().getAscendant("div", true);

    //       // Initialization of the CKEditor 4 data transfer facade is a necessary step to extend and unify native
    //       // browser capabilities. For instance, Internet Explorer does not support any other data type than 'text' and 'URL'.
    //       // Note: evt is an instance of CKEDITOR.dom.event, not a native event.
    //       (CKEDITOR as any).plugins.clipboard.initDragDataTransfer(evt);

    //       const dataTransfer = evt.data.dataTransfer;

    //       // Pass an object with contact details. Based on it, the editor#paste listener in the hcard plugin
    //       // will create the HTML code to be inserted into the editor. You could set 'text/html' here as well, but:
    //       // * It is a more elegant and logical solution that this logic is kept in the hcard plugin.
    //       // * You do not know now where the content will be dropped and the HTML to be inserted
    //       // might vary depending on the drop target.
    //       dataTransfer.setData("contact", CONTACTS[target.data("contact")]);

    //       // You need to set some normal data types to backup values for two reasons:
    //       // * In some browsers this is necessary to enable drag and drop into text in the editor.
    //       // * The content may be dropped in another place than the editor.
    //       dataTransfer.setData("text/html", target.getText());

    //       // You can still access and use the native dataTransfer - e.g. to set the drag image.
    //       // Note: IEs do not support this method... :(.
    //       if (dataTransfer.$.setDragImage) {
    //         dataTransfer.$.setDragImage(target.findOne("img").$, 0, 0);
    //       }
    //     });
    // });

    // Initialize the editor with the hcard plugin.
    // CKEDITOR.inline("textAreaId", {
    //   extraPlugins: "hcard,sourcedialog,justify",
    // });
  }
  destroyed() {
    this.editor?.destroy();
    this.editor = null;
  }
  destroyedMy() {
    if (!this.editor) return;
    this.editor?.destroy();
    this.editor = null;
  }
}
